import React, { FC } from 'react';

const ErrorIcon: FC = () => (
    <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='25' cy='25' r='25' fill='#F20D59' />
        <path d='M18 32L32 18M18 18L32 32' stroke='white' strokeWidth='3.2' />
    </svg>
);

export default ErrorIcon;
